
import React, { useState } from 'react';

export const TestimonialsSection: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      rating: 5,
      quote: "Working with SellApartmentsCash was incredibly smooth. They closed on our 24-unit property in just 12 days with no hassles or surprises. The cash offer was fair and the process was transparent from start to finish.",
      name: "Michael Rodriguez",
      propertyType: "24-Unit Garden Complex Owner",
      avatar: "https://public.readdy.ai/ai/img_res/ccc23e6c6187bd8fe40bb7dd3db2ef41.jpg"
    },
    {
      rating: 5,
      quote: "I needed to sell my mixed-use building quickly due to family circumstances. They understood my situation and made it happen in 14 days. No repairs needed, no agent fees, just a straightforward cash transaction.",
      name: "Sarah Chen",
      propertyType: "Mixed-Use Building Owner",
      avatar: "https://readdy.ai/api/search-image?query=professional%20asian%20businesswoman%20headshot%20portrait%2C%20commercial%20property%20owner%2C%20confident%20real%20estate%20investor%2C%20clean%20corporate%20photography%20style&width=70&height=70&seq=avatar-002&orientation=squarish"
    },
    {
      rating: 5,
      quote: "After trying to sell through traditional methods for 8 months, SellApartmentsCash gave us a fair cash offer within 24 hours. The closing was seamless and we finally moved on with our investment plans.",
      name: "David Thompson",
      propertyType: "42-Unit Apartment Complex Owner",
      avatar: "https://readdy.ai/api/search-image?query=professional%20caucasian%20businessman%20headshot%20portrait%2C%20apartment%20building%20owner%2C%20mature%20real%20estate%20investor%2C%20clean%20corporate%20photography%20style&width=70&height=70&seq=avatar-003&orientation=squarish"
    }
  ];

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            What Property Owners Say
          </h2>
          <p className="text-xl text-gray-600">
            Real experiences from multifamily property sellers across America
          </p>
        </div>

        <div className="relative max-w-4xl mx-auto">
          <div className="bg-gray-50 rounded-2xl p-8 lg:p-12">
            <div className="flex justify-center mb-6">
              {[...Array(testimonials[currentIndex].rating)].map((_, i) => (
                <i key={i} className="ri-star-fill text-orange-500 text-xl mx-1"></i>
              ))}
            </div>

            <blockquote className="text-xl lg:text-2xl text-gray-800 italic leading-relaxed mb-8 text-center">
              "{testimonials[currentIndex].quote}"
            </blockquote>

            <div className="flex items-center justify-center">
              <img 
                src={testimonials[currentIndex].avatar}
                alt={testimonials[currentIndex].name}
                className="w-16 h-16 rounded-full object-cover mr-4"
              />
              <div>
                <div className="font-semibold text-gray-900 text-lg">
                  {testimonials[currentIndex].name}
                </div>
                <div className="text-gray-600">
                  {testimonials[currentIndex].propertyType}
                </div>
              </div>
            </div>
          </div>

          {/* Navigation Buttons */}
          <button 
            onClick={prevTestimonial}
            className="absolute left-4 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-gray-50 transition-colors"
          >
            <i className="ri-arrow-left-line text-gray-600 text-xl"></i>
          </button>

          <button 
            onClick={nextTestimonial}
            className="absolute right-4 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-gray-50 transition-colors"
          >
            <i className="ri-arrow-right-line text-gray-600 text-xl"></i>
          </button>

          {/* Dots Indicator */}
          <div className="flex justify-center mt-8 space-x-2">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`w-3 h-3 rounded-full transition-colors ${
                  index === currentIndex ? 'bg-orange-500' : 'bg-gray-300'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
